import { useVetisAccessDrawers } from "../lib/useVetisAccessDrawers"
import { FC, useState } from "react";
import { NewEntrieBody, NewEntrieFooter, NewEntrieHead, NewEntrieRow, NewEntrieTextAreaWrapper, NewEntrieTitle, NewEntrieWrapper } from "./style";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { Drawer } from "shared/ui/drawer";
import { Controller } from "react-hook-form";
import Input from '@atomaro/ui-kit/components/Input/Input';
import { useResize } from "app/lib/hooks/useResize";
import { CloseIcon, PassHide, PassShow } from "shared/ui/icons";
import { toRem } from "shared/helpers";
import { Spacer } from "shared/ui/spacer";

export const VetisAccessDrawers: FC = () => {
  const [ showPass, setShowPass ] = useState<boolean>(false);
  const { isScreenMd } = useResize();

  const {
    isLoading,

    isBusinessModalOpen,
    businessControl,
    businessErrors,

    isUserModalOpen,
    userControl,
    userErrors,

    businesshandleSubmit,
    onBusinessClose,
    onBusinessSubmit,

    userhandleSubmit,
    onUserClose,
    onUserSubmit,

    onReset,
  } = useVetisAccessDrawers()

  return (
    <>
      <Drawer
        position="right"
        isOpen={isBusinessModalOpen}
        onClose={onBusinessClose}
      >
        <NewEntrieWrapper 
          onSubmit={businesshandleSubmit(onBusinessSubmit)}
          className={isLoading ? "_skeleton" : ""}
        >
          <NewEntrieHead $isMobile={!isScreenMd}>
            <Button
              iconPrefix={<CloseIcon />}
              variant={!isScreenMd ? "ghost" : "secondary"}
              colorScheme="neutral"
              style={{
                alignSelf: "flex-end",
                width: !isScreenMd ? toRem(24) : toRem(36),
              }}
              size={!isScreenMd ? "s" : "m"}
              onClick={onBusinessClose}
            />
            <NewEntrieTitle>
              Добавление данных
            </NewEntrieTitle>
            {!isScreenMd && <Spacer width={toRem(24)} height={toRem(24)} />}
          </NewEntrieHead>
          <NewEntrieBody>
            <NewEntrieRow>
              <span>Имя пользователя</span>
              <Controller 
                control={businessControl}
                name="login"
                rules={{
                  required: 'Это обязательное поле'
                }}
                render={({field}) => (
                  <div>
                    <Input 
                      size="m"
                      placeholder="Login"
                      name={field.name}
                      value={field.value}
                      error={businessErrors.login?.message}
                      onChange={(event) => field.onChange(event.target.value)}
                    />
                  </div>
                )}
              />
            </NewEntrieRow>
            <NewEntrieRow>
              <span>Пароль</span>
              <Controller 
                control={businessControl}
                name="password"
                rules={{
                  required: 'Это обязательное поле'
                }}
                render={({field}) => (
                  <div>
                    <Input 
                      size="m"
                      placeholder="Password"
                      name={field.name}
                      value={field.value}
                      type={showPass ? 'text' : 'password'}
                      onChange={(event) => field.onChange(event.target.value)}
                      iconSuffix={showPass ? <PassShow /> : <PassHide />}
                      onClickIconSuffix={() => setShowPass(!showPass)}
                      error={businessErrors.password?.message}
                    />
                  </div>
                )}
              />
            </NewEntrieRow>
            <NewEntrieRow>
              <span>Апи ключ</span>
              <Controller 
                control={businessControl}
                name="apiKey"
                rules={{
                  required: 'Это обязательное поле'
                }}
                render={({field}) => (
                  <div style={{flex: '1 1 auto'}}>
                    <NewEntrieTextAreaWrapper>
                      <textarea
                        name={field.name}
                        value={field.value}
                        onChange={(event) => field.onChange(event.target.value)}
                        placeholder="APIKey"
                      ></textarea>
                    </NewEntrieTextAreaWrapper>
                    {businessErrors?.apiKey?.message && 
                    <div className="input__hint">
                      <div className="input__hint-label">{businessErrors.apiKey.message}</div>
                    </div>
                    }
                  </div>
                )}
              />
            </NewEntrieRow>
            <NewEntrieRow>
              <span>IssuerID</span>
              <Controller 
                control={businessControl}
                name="issuerId"
                rules={{
                  required: 'Это обязательное поле'
                }}
                render={({field}) => (
                  <div>
                    <Input 
                      size="m"
                      placeholder="IssuerID"
                      name={field.name}
                      value={field.value}
                      onChange={(event) => field.onChange(event.target.value)}
                      error={businessErrors.issuerId?.message}
                    />
                  </div>
                )}
              />
            </NewEntrieRow>
          </NewEntrieBody>
          <NewEntrieFooter>
            <Button
              type="submit"
              label="Сохранить"
            />
            <Button
              label="Отменить"
              variant="ghost"
              colorScheme="neutral"
              onClick={onReset}
            />
          </NewEntrieFooter>
        </NewEntrieWrapper>
      </Drawer>
      <Drawer
        position="right"
        isOpen={isUserModalOpen}
        onClose={onUserClose}
      >
        <NewEntrieWrapper 
          onSubmit={userhandleSubmit(onUserSubmit)}
          className={isLoading ? "_skeleton" : ""}
        >
          <NewEntrieHead $isMobile={!isScreenMd}>
            <Button
              iconPrefix={<CloseIcon />}
              variant={!isScreenMd ? "ghost" : "secondary"}
              colorScheme="neutral"
              style={{
                alignSelf: "flex-end",
                width: !isScreenMd ? toRem(24) : toRem(36),
              }}
              size={!isScreenMd ? "s" : "m"}
              onClick={onUserClose}
            />
            <NewEntrieTitle>
              Добавление данных
            </NewEntrieTitle>
            {!isScreenMd && <Spacer width={toRem(24)} height={toRem(24)} />}
          </NewEntrieHead>
          <NewEntrieBody>
            <NewEntrieRow>
              <span>Имя пользователя</span>
              <Controller 
                control={userControl}
                name="login"
                rules={{
                  required: 'Это обязательное поле'
                }}
                render={({field}) => (
                  <div>
                    <Input 
                      size="m"
                      placeholder="Login"
                      name={field.name}
                      value={field.value}
                      error={userErrors.login?.message}
                      onChange={(event) => field.onChange(event.target.value)}
                    />
                  </div>
                )}
              />
            </NewEntrieRow>
          </NewEntrieBody>
          <NewEntrieFooter>
            <Button
              type="submit"
              label="Сохранить"
            />
            <Button
              label="Отменить"
              variant="ghost"
              colorScheme="neutral"
              onClick={onReset}
            />
          </NewEntrieFooter>
        </NewEntrieWrapper>
      </Drawer>
    </>
  )
}